export enum RoutesRestrictionType {
  MobileRestricted = 'mobile',
  DesktopRestricted = 'desktop',
}
